export const points = [
  {
    name: "Linea Ignition Rewards",
    logo: "/points/linea.svg",
    collateralVaults: [
      "0xa8A02E6a894a490D04B6cd480857A19477854968",
      "0xF4712fC5E6483DE9e1Ff661D95DD686664327086",
      "0x8bf8EdC911Ab3f0ea4a27c51Cb88b57ccE5356f1",
      "0x179DfD3eCDC6f5B8F8788584F3289D10c6F1afb8",
      "0x14EfcC1Ae56e2fF75204Ef2Fb0DE43378d0beaDA",
      "0x085f80Df643307e04f23281F6fdbfAA13865E852",
      "0x9aC2F0A564B7396A8692E1558d23a12d5a2aBb1F",
      "0xb135dcF653DAFB5ddAa93F926D7000Aa3222EFEE",
      "0xfB6448B96637d90FcF2E4Ad2c622A487d0496e6f",
      "0xCBeF9be95738290188B25ca9A6Dd2bEc417a578c",
      "0x0272f12b58bee8579FDff3037E62D4a20f01Cb88",
      "0xf00be6427F6EFC27d065D15c8e3462F0Ee41Ad6b",
      "0xA7ada0D422a8b5FA4A7947F2CB0eE2D32435647d",
      "0xFD3246606Cb9678C9109A5eCdDb37cA8E8F749cF",
      "0xc99FeC400176498825A9Cb376a08AF8346675A46",
      "0xa4FAc70b76C39cfb92A819E23EAe057f1D76748B",
      "0x0B6d98D6250e6F11c86C013CAa009B2eAcaD0D7E",
    ],
  },
  {
    name: "Linea Ignition Rewards - forwarded from eligible allocated vaults",
    logo: "/points/linea.svg",
    collateralVaults: [
      "0xe9De3063d282c7C1F34BfEF8E1e67410dCd60597",
      "0xb25a72791e6B543A84128791cfc849E5f55f7249",
    ],
  },
] as const
